export default __webpack_public_path__ + "01b09a9ec1fc4731653d05e2bbc3204a.svg";